"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useState } from "react";

export const useLaunchCommunity = () => {
    const router = useRouter();
    const searchParams = useSearchParams();
    const [isCommunityCreateVisible, setIsCommunityCreateVisible] = useState(
        () => {
            return searchParams?.get("createCommunity") === "true";
        },
    );
    const setCreateCommunityVisible = (
        visible: boolean,
        routing: boolean = false,
    ) => {
        setIsCommunityCreateVisible(visible);

        const newUrl = new URL(window.location.href);
        if (visible) {
            newUrl.searchParams.set("createCommunity", "true");
        } else {
            newUrl.searchParams.delete("createCommunity");
        }

        // if creating a community, we don't want to hijack the routing since a new community is being created
        if (!routing) {
            router.replace(newUrl.pathname + newUrl.search, {
                scroll: false,
            });
        }
    };

    return { isCommunityCreateVisible, setCreateCommunityVisible };
};
